<template>
    <svg width="44" height="26" class="zipcode-icon" viewBox="0 0 44 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.3684 14.7778L17.0263 19.2222L9.8421 25H25.3158V12.5556L34.7105 17.8889V12.5556H43V9L28.0789 4.55556V1H15.3684V9H1V14.7778H15.3684Z" stroke="#777777" stroke-width="2"/>
    </svg>
</template>
<script>
export default {}
</script>